import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Floatingcall from "../components/floatingbutton/Floatingcall";
import { Helmet } from "react-helmet";
import LandingPageClient from "../components/ladingpageclient/LandingPageClient";
import {FaUsers} from "react-icons/fa";

function HousekeepingManpower(){

const testimonials = [
  {
    name: "Rahul Sharma",
    role: "Business Owner",
    feedback:
      "The Helper Ji housekeeping staff understood our routine in a few days. We don’t have to keep repeating instructions.",
    image: "https://i.pravatar.cc/150?img=12",
  },
  {
    name: "Neha Verma",
    role: "Working Professional",
    feedback:
      "Work is completed on time, and behavior is respectful. HelperJi's manpower has been reliable so far.",
    image: "https://i.pravatar.cc/150?img=32",
  },
  {
    name: "Amit Singh",
    role: "Corporate Manager",
    feedback:
      "Earlier, helpers used to change frequently. Since Helper Ji provided housekeeping manpower, attendance has been stable.",
    image: "https://i.pravatar.cc/150?img=56",
  },
];


    const services = [
        {
          name: "Housekeeping Manpower Services Gurugram",
          link: "/housekeeping-manpower-services-gurugram",
          icon: <FaUsers />
        },
        {
          name: "Housekeeping Manpower Services Ghaziabad",
          link: "/housekeeping-manpower-services-ghaziabad",
          icon: <FaUsers />
        },
        {
          name: "Housekeeping Manpower Services Noida",
          link: "/housekeeping-manpower-services-noida",
          icon: <FaUsers />
        },
         {
          name: "Housekeeping Manpower Services Delhi",
          link: "/housekeeping-manpower-services-delhi",
          icon: <FaUsers />
        }
      ];

    return(
        <Fragment>
          <Helmet>
             <title>
          Professional Housekeeping Manpower Services | Corporate Housekeeping Services
        </title>

        <meta
          name="description"
          content="Professional housekeeping manpower services offering corporate housekeeping services through a trusted housekeeping manpower agency for corporates & commercial businesses."
        />

        <meta
          name="keywords"
          content="Housekeeping Manpower Services, Corporate Housekeeping Services, Housekeeping Manpower Agency, Housekeeping Manpower Agency Near Me, Housekeeping Services For Corporates, Professional Housekeeping Manpower, Housekeeping Company In Noida, Housekeeping Manpower Agency In Noida"
        />

        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta name="bingbot" content="index, follow" />
        <meta name="revisit-after" content="daily" />
        <meta name="allow-search" content="yes" />
        <meta name="copyright" content="Helper Ji" />

        {/* ===== CANONICAL ===== */}
        <link
          rel="canonical"
          href="https://www.helperji.in/housekeeping-manpower-services"
        />

        {/* ===== OPEN GRAPH ===== */}
        <meta
          property="og:title"
          content="Professional Housekeeping Manpower Services | Corporate Housekeeping Services"
        />
        <meta
          property="og:description"
          content="Professional housekeeping manpower services offering corporate housekeeping services through a trusted housekeeping manpower agency for corporates & commercial businesses."
        />
        <meta
          property="og:image"
          content="https://www.helperji.in/assets/img/housekeeping1.png"
        />
        <meta property="og:site_name" content="Helper Ji" />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.helperji.in/housekeeping-manpower-services"
        />

        {/* ===== TWITTER META ===== */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@helperji_" />
        <meta name="twitter:creator" content="@helperji_" />
        <meta
          name="twitter:title"
          content="Professional Housekeeping Manpower Services | Corporate Housekeeping Services"
        />
        <meta
          name="twitter:description"
          content="Professional housekeeping manpower services offering corporate housekeeping services through a trusted housekeeping manpower agency for corporates & commercial businesses."
        />
        <meta
          name="twitter:image"
          content="https://www.helperji.in/assets/img/housekeeping1.png"
        />

        {/* ===== WEBPAGE SCHEMA ===== */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "url": "https://www.helperji.in/housekeeping-manpower-services",
            "name": "Professional Housekeeping Manpower Services | Corporate Housekeeping Services",
            "description": "Professional housekeeping manpower services offering corporate housekeeping services through a trusted housekeeping manpower agency for corporates & commercial businesses."
          }
          `}
        </script>

        {/* ===== SERVICE Schema ===== */}
        <script type="application/ld+json">
  {`
  {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Housekeeping Manpower Services",
    "image": "https://www.helperji.in/assets/img/housekeeping1.png",
    "description": "Professional housekeeping manpower services offering corporate housekeeping services through a trusted housekeeping manpower agency for corporates & commercial businesses.",
    "brand": {
      "@type": "Brand",
      "name": "Helper Ji"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.7",
      "ratingCount": "758"
    }
  }
  `}
</script>

        {/* ===== BREADCRUMB SCHEMA ===== */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.helperji.in"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Housekeeping Manpower Services",
                "item": "https://www.helperji.in/housekeeping-manpower-services"
              }
            ]
          }
          `}
        </script>
          <script type="text/javascript">
    {`
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "vuhgim22tp");
    `}
  </script>
          </Helmet>
            
            <Floatingcall />

            <section id="about" className="about">
            <div className="container" data-aos="fade-up">

            <div className="section-header">
            <h2>Housekeeping Manpower Services</h2>
            <p>HelperJi: Expert Domestic Staffing Services </p>
             </div>

           <div className="row gy-4">
           <div className="col-lg-6">
            <img src="/assets/img/housekeeping1.png" className="img-fluid rounded-4 mb-4" alt="" />
            
            </div>
          
          <div className="col-lg-6">
            <div className="content ps-0 ps-lg-5">
              <h3 className="fst-italic">
              Among the housekeeping manpower services we offer are:
              </h3>
              <ul>
                <li className="text-justify"><b>Floor Cleaning and Maintenance:</b> Whether your floors are hardwood, tiled, or carpeted, we guarantee that they are always immaculate and attractive.</li>
                <li className="text-justify"><b>Dusting and Sanitizing:</b> To maintain a hygienic atmosphere, our staff carefully dusts and sanitises all surfaces, including furniture, electronics, and communal areas.                </li>
                <li className="text-justify"><b>Bathroom and Restroom Cleaning: </b>We keep restrooms sanitised, clean, and restocked with supplies that are always presentable and fresh.</li>
                <li className="text-justify"><b>Pantry and Kitchen Area Cleaning:</b> Our crew takes care of every little thing, from countertops to appliances, to keep your pantry and kitchen areas sanitary and spotless.</li>
                <li className="text-justify"><b>Garbage Management: </b>Our housekeeping crew makes sure that garbage is disposed of effectively, that the area is kept clean, and that environmental regulations are followed.</li>
                <li className="text-justify"><b>Furniture & Upholstery Care:</b> To keep couches, chairs, and other upholstery in top shape, we provide expert cleaning.</li>
                <li className="text-justify"><b>Glass and window cleaning</b> is handled by our staff, who will leave your windows and glass surfaces immaculate after cleaning both inside and outside.</li>
                <li className="text-justify"><b>Specialised Cleaning Tasks:</b> Our housekeeping services take care of every detail, from conference rooms to high-touch locations like light switches and door handles.</li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </section>

    <section id="services" className="services sections-bg">
          <div className="container" data-aos="fade-up">

            <div className="row gy-4">
              
              <div className="col-lg-6">
                <div className="content ps-0 ps-lg-5">
                  <h2>
                  Why Opt for Housekeeping Services from Helper Ji?: 
                  </h2>
                  <p className="text-justify">Helper Ji is proud to provide premium housekeeping staffing services that are customised to your needs. In order to guarantee a clean and well-maintained place, we offer professional and educated housekeeping workers for any type of setting—corporate, residential, or hospitality. Being a top provider of housekeeping services, we stand out due to our dedication to excellence and meticulousness.</p>
                <ul>
                  <li className="text-justify"><b>Skilled Professionals:</b> To deliver excellent services while upholding safety and hygiene regulations, our housekeeping staff goes through extensive training.</li>

                  <li className="text-justify"><b>Customised Services:</b> To ensure optimal effectiveness and satisfaction, we customise our housekeeping services to match the unique requirements of your establishment.</li>
                  
                  <li className="text-justify"><b>Cost-effective and Dependable:</b> We provide competitive pricing without sacrificing service quality, so you always get the most out of your investment.</li>
                  
                  <li className="text-justify"><b>Compliant & Trusted: </b>Helper Ji is a reliable partner for all of your housekeeping needs since we adhere to all industry and governmental regulations.</li>
                </ul>
                </div>
              </div>
              <div className="col-lg-6">
                <img src="/assets/img/housekeeping4.png" class="img-fluid rounded-4 mb-4" alt="" />
              </div>
            </div>
    
          </div>
        </section>

       <section className="py-5 bg-white">
      <div className="container">
        {/* Heading */}
        <div className="text-center mb-5">
          <h2 className="fw-bold">What Our <span style={{ color: "#ED1C24" }}>Clients Say</span> </h2>
          <p className="text-muted">
            Trusted by thousands of satisfied customers
          </p>
        </div>

        {/* Testimonials */}
        <div className="row g-4">
          {testimonials.map((item, index) => (
            <div className="col-md-6 col-lg-4" key={index}>
              <div className="card bg-light h-100 shadow-sm border-0 text-center p-4">
                <img
                  src={item.image}
                  alt={item.name}
                  className="rounded-circle mx-auto mb-3"
                  width="90"
                  height="90"
                />

                <p className="text-muted fst-italic">
                  “{item.feedback}”
                </p>

                <h5 className="fw-semibold mb-0">{item.name}</h5>
                <small className="text-danger">{item.role}</small>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

         <section id="services" className="services sections-bg">
        <div className="container">
          <h3 className="pb-4">
            FAQs – Housekeeping Manpower Services
          </h3>
          <div className="accordion accordion-flush" id="accordionFlushExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingOne">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseOne"
                  aria-expanded="false"
                  aria-controls="flush-collapseOne"
                >
                 What do corporate housekeeping services include?
                </button>
              </h2>
              <div
                id="flush-collapseOne"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingOne"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Corporate housekeeping services cover professional manpower for office cleaning, sanitation, pantry maintenance, restroom hygiene, and daily upkeep.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingTwo">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseTwo"
                  aria-expanded="false"
                  aria-controls="flush-collapseTwo"
                >
                  Are you a housekeeping manpower agency near me ?
                </button>
              </h2>
              <div
                id="flush-collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingTwo"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                 Yes, Helper Ji is a trusted housekeeping manpower agency near me, delivering reliable staffing solutions for corporate environments.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingThree">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseThree"
                  aria-expanded="false"
                  aria-controls="flush-collapseThree"
                >
                  Do you provide housekeeping services for corporates?
                </button>
              </h2>
              <div
                id="flush-collapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingThree"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Yes, we offer complete housekeeping services for corporates, tailored to business needs and operational hours.
                </div>
              </div>
            </div>
             <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingFour">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFour"
                  aria-expanded="false"
                  aria-controls="flush-collapseFour"
                >
                  What housekeeping manpower services are available?
                </button>
              </h2>
              <div
                id="flush-collapseFour"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFour"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Our housekeeping manpower services include floor maintenance, dusting, sanitizing, restroom cleaning, pantry cleaning, garbage disposal, furniture cleaning, and glass cleaning.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingFive">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFive"
                  aria-expanded="false"
                  aria-controls="flush-collapseFive"
                >
                  Why choose Helper Ji for housekeeping services?
                </button>
              </h2>
              <div
                id="flush-collapseFive"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFive"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                 Helper Ji is known for skilled manpower, affordable pricing, and full compliance with regulations in corporate housekeeping services.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

       <LandingPageClient />

              <section className="py-5 sections-bg">
                         <div className="container">
                           <div className="row mb-4">
                             <div className="col text-center">
                               <h2 className="fw-bold">Our Locations</h2>
                               <p className="text-muted">
                                 Explore Our locations of Housekeeping Manpower
                                 Services
                               </p>
                             </div>
                           </div>
                   
                           <div className="row g-4">
                             {services.map((service, index) => (
                               <div className="col-md-3 col-sm-6" key={index}>
                                 <Link
                                   to={service.link}
                                   className="text-decoration-none text-dark"
                                 >
                                   <div className="card h-100 shadow-sm border-0 service-card">
                                     <div className="card-body d-flex align-items-center">
                                       <div className="service-icon me-3">
                                         {service.icon}
                                       </div>
                                       <h6 className="mb-0 fw-semibold">
                                         {service.name}
                                       </h6>
                                     </div>
                                   </div>
                                 </Link>
                               </div>
                             ))}
                           </div>
                         </div>
                       </section>

        </Fragment>
    )
}

export default HousekeepingManpower;